const getAugmentedPhoneNumbers = function (state) {

  return function (collection: any[]) {
    const result = collection?.map(item => {
      const phoneNumber = item?.phoneNumber ?? item?.phone_number
      const sid = item?.sid
      item.client = {
        inHighLevelDB: Boolean(
          state.locationTwilio?.numbers[phoneNumber]
        ),
        isDefaultOutboundNumber: Boolean(
          state.locationTwilio?.defaultOutboundNumber === phoneNumber
        ),
        isA2PVerified: Boolean(
          state.phoneNumbersA2PLookup[sid]
        )
      }

      return item
    })
    return result
  }
}

export default getAugmentedPhoneNumbers
